import { render, staticRenderFns } from "./MetricsSidebar.vue?vue&type=template&id=24794492&"
import script from "./MetricsSidebar.vue?vue&type=script&lang=ts&"
export * from "./MetricsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./MetricsSidebar.vue?vue&type=style&index=0&id=24794492&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports